import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { mountStoreDevtool } from 'simple-zustand-devtools';




const useAuthApp = create(
    persist(
        (set, get) => ({
            allUserData: null,
            loading: false,

            user: () => ({
                user_id: get().allUserData?.user_id || null,
                first_name: get().allUserData?.first_name || null,
                last_name: get().allUserData?.last_name || null,
            }),

            setUser: (user) => set({ 
                allUserData: user,
                isLoggedIn: user !== null
             }),
            setLoading: (loading) => set({ loading }),

            // isLoggedIn: () => get().allUserData !== null,
            isLoggedIn: false,
        }),
        // {
        //     name: 'auth-storage', // Key in localStorage
        //     getStorage: () => localStorage, // Use localStorage to persist data
        // }
    )
);

if(import.meta.env.DEV){
    mountStoreDevtool('winefacts', useAuthApp)
}

export { useAuthApp }